import MainOverruleCustomsLight from '../../global/components/overrule-customs-light/MainOverruleCustomsLight';

const OverruleCustomsLight: React.FC = () => {
  return <MainOverruleCustomsLight partyPath={'terminal'} />;
};

export default OverruleCustomsLight;
